import { catalog } from '@atlassiansox/metal-client';
import { BMInteractionMetrics, BMPageLoadMetrics, StorableBMEventsType } from '../types';
const metricNameMatrix = {
  pageLoad: {
    fmp: {
      gauge: catalog.performance.FIRST_MEANINGFUL_PAINT,
      slo: catalog.performance.FIRST_MEANINGFUL_PAINT_SLO
    },
    tti: {
      gauge: catalog.performance.TIME_TO_INTERACTIVE,
      slo: catalog.performance.TIME_TO_INTERACTIVE_SLO
    }
  },
  pageSegmentLoad: {
    fmp: {
      gauge: catalog.performance.FIRST_MEANINGFUL_PAINT,
      slo: catalog.performance.FIRST_MEANINGFUL_PAINT_SLO
    },
    tti: {
      gauge: catalog.performance.TIME_TO_INTERACTIVE,
      slo: catalog.performance.TIME_TO_INTERACTIVE_SLO
    }
  },
  interaction: {
    response: {
      gauge: catalog.userInteraction.TASK_TIME_TO_FEEDBACK,
      slo: catalog.userInteraction.TASK_TIME_TO_FEEDBACK_SLO
    },
    result: {
      gauge: catalog.userInteraction.TASK_TIME_TO_COMPLETE,
      slo: catalog.userInteraction.TASK_TIME_TO_COMPLETE_SLO
    }
  },
  custom: {
    gauge: catalog.userInteraction.TASK_DURATION,
    sloSuccess: catalog.userInteraction.TASK_SUCCESS,
    sloFailure: catalog.userInteraction.TASK_FAILURE
  }
};

const makePageLoadPayload = (payload, type, common) => {
  const metricName = `metric:${type}`;
  const metricNameSlo = `metric:${type}:slo`;
  const histogramNameSlo = `metric:${type}:histogramBuckets`;
  const metalPayload = { ...common,
    name: metricNameMatrix.pageLoad[type].gauge,
    value: payload[metricName]
  };
  const slo = payload[metricNameSlo];
  const histogram = payload[histogramNameSlo];
  const payloads = [];

  if (histogram !== undefined) {
    const histogramEvent = { ...metalPayload,
      histogramBuckets: histogram
    };
    payloads.push(histogramEvent);
  }

  if (slo !== undefined) {
    const sloEvent = { ...metalPayload,
      name: metricNameMatrix.pageLoad[type].slo,
      value: 1,
      success: slo
    };
    payloads.push(sloEvent);
  }

  return payloads;
};

const makeInteractionPayload = (payload, type) => {
  const metricName = `metric:${type}`;
  const metricNameSlo = `metric:${type}:slo`;
  const histogramNameSlo = `metric:${type}:histogramBuckets`;
  const gaugeValue = metricName in payload && payload[metricName];

  if (!gaugeValue && typeof gaugeValue !== 'number') {
    return [];
  }

  const metalPayload = {
    name: metricNameMatrix.interaction[type].gauge,
    value: gaugeValue,
    task: payload['event:id'],
    page: payload['event:route'] || ''
  };
  const payloads = [];
  const histogram = payload[histogramNameSlo];

  if (histogram !== undefined) {
    const histogramEvent = { ...metalPayload,
      histogramBuckets: histogram
    };
    payloads.push(histogramEvent);
  }

  if (metricNameSlo in payload) {
    const sloPayload = { ...metalPayload,
      name: metricNameMatrix.interaction[type].slo,
      value: 1,
      success: !!payload[metricNameSlo]
    };
    payloads.push(sloPayload);
  }

  return payloads;
};

const makeCustomPayload = payload => {
  const gaugeValue = payload['metric:duration'];

  if (!gaugeValue && typeof gaugeValue !== 'number') {
    return [];
  }

  const metalPayload = {
    name: metricNameMatrix.custom.gauge,
    value: gaugeValue,
    task: payload['event:id'],
    page: payload['event:route'] || ''
  };
  const payloads = [];
  const histogram = payload['metric:duration:histogramBuckets'];

  if (histogram !== undefined) {
    const histogramEvent = { ...metalPayload,
      histogramBuckets: histogram
    };
    payloads.push(histogramEvent);
  }

  if ('metric:duration:slo' in payload) {
    const sloPayload = { ...metalPayload,
      name: payload['metric:duration:slo'] ? metricNameMatrix.custom.sloSuccess : metricNameMatrix.custom.sloFailure,
      value: 1
    };
    payloads.push(sloPayload);
  }

  return payloads;
};

export const metalDataProcessor = (payload, useVisibleState) => {
  if (payload['event:type'] === StorableBMEventsType.PAGE_LOAD || payload['event:type'] === StorableBMEventsType.PAGE_SEGMENT_LOAD) {
    // page segment reuses METAL page load events
    const prefix = payload['event:type'] === StorableBMEventsType.PAGE_SEGMENT_LOAD ? 'segment-' : '';
    const isActiveTab = useVisibleState ? payload['pageVisible:state'] === 'visible' : payload['pageVisible:value'];
    const common = {
      page: `${prefix}${payload['event:id']}`,
      isInitial: payload['event:initial'],
      isActiveTab
    };
    return [...makePageLoadPayload(payload, BMPageLoadMetrics.fmp, common), ...makePageLoadPayload(payload, BMPageLoadMetrics.tti, common)];
  }

  if (payload['event:type'] === StorableBMEventsType.INLINE_RESULT) {
    const payloads = [];

    if (payload['metric:response']) {
      payloads.push(...makeInteractionPayload(payload, BMInteractionMetrics.response));
    }

    payloads.push(...makeInteractionPayload(payload, BMInteractionMetrics.result));
    return payloads;
  }

  if (payload['event:type'] === StorableBMEventsType.CUSTOM) {
    return makeCustomPayload(payload);
  }

  return [];
};